export interface CategoryLink {
  name: string;
  href: string;
  key: string;
}

export const categoryLinks: CategoryLink[] = [
  {
    name: 'Shoes',
    href: 'https://kaspreadsheet.com/category-911-Shoes.html',
    key: 'shoes',
  },
  {
    name: 'Hoodies/Sweaters',
    href: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    key: 'hoodies',
  },
  {
    name: 'T-Shirts',
    href: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    key: 'tshirts',
  },
  {
    name: 'Jackets',
    href: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    key: 'jackets',
  },
  {
    name: 'Pants/Shorts',
    href: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    key: 'pants',
  },
  {
    name: 'Headwear',
    href: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    key: 'headwear',
  },
  {
    name: 'Sets',
    href: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    key: 'sets',
  },
  {
    name: 'Underwear/Underpants',
    href: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    key: 'underwear',
  },
  {
    name: 'Jersey',
    href: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    key: 'jersey',
  },
  {
    name: 'Accessories',
    href: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    key: 'accessories',
  },
  {
    name: 'Bags',
    href: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    key: 'bags',
  },
  {
    name: 'Belts',
    href: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    key: 'belts',
  },
  {
    name: 'Perfumes',
    href: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    key: 'perfumes',
  },
  {
    name: 'Other Stuff',
    href: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    key: 'other',
  },
];